export const env = process.env.REACT_APP_ENV;
export const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
export const idValidationUrl = process.env.REACT_APP_USER_VERIFY_URL;
export const oktaIssuer = process.env.REACT_APP_OKTA_ISSUER;
export const oktaClientId = process.env.REACT_APP_OKTA_CLIENT_ID;
